/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Mock_Msg_AyseInputs */

const tr_landing_community_mock_msg_ayse = /** @type {(inputs: Landing_Community_Mock_Msg_AyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trendyol kampanya fiyatını otomatik çıkarmak isteyen? Kural paylaşabilirim.`)
};

const en_landing_community_mock_msg_ayse = /** @type {(inputs: Landing_Community_Mock_Msg_AyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anyone want to auto-calculate the Trendyol campaign price? I can share my rule.`)
};

const de_landing_community_mock_msg_ayse = /** @type {(inputs: Landing_Community_Mock_Msg_AyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Will jemand den Trendyol-Kampagnenpreis automatisch berechnen? Ich kann eine Regel teilen.`)
};

const ru_landing_community_mock_msg_ayse = /** @type {(inputs: Landing_Community_Mock_Msg_AyseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кто хочет автоматически рассчитывать акционную цену Trendyol? Могу поделиться правилом.`)
};

/**
* | output |
* | --- |
* | "Anyone want to auto-calculate the Trendyol campaign price? I can share my rule." |
*
* @param {Landing_Community_Mock_Msg_AyseInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_mock_msg_ayse = /** @type {((inputs?: Landing_Community_Mock_Msg_AyseInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Mock_Msg_AyseInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_mock_msg_ayse(inputs)
	if (locale === "de") return de_landing_community_mock_msg_ayse(inputs)
	if (locale === "ru") return ru_landing_community_mock_msg_ayse(inputs)
	return tr_landing_community_mock_msg_ayse(inputs)
});